import { User } from '../models/user.model';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

import myDataQuery from 'src/app/graphql/queries/my_data.query.graphql'
import updateDataQuery from 'src/app/graphql/mutations/update_my_data.mutation.graphql'

@Injectable()
export class UserService extends GraphQLService<User> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  getMyData(): Observable<User> {
    return this.find(myDataQuery)
  }

  updateMyData(accountInformation: {}, companyInformation: {}): Observable<User> {
    return this.push(updateDataQuery, {...accountInformation, ...companyInformation})
  }

}
